var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhWert = function SvgPhWert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "PH-Wert_svg__Ebene_2",
    viewBox: "0 0 88.82 106.18"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".PH-Wert_svg__cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2.3px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PH-Wert_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.95 17.16H22.87L1.33 54.47l21.54 37.32h43.08L87.5 54.47zM22.87 17.16 14.89.5M22.87 91.79l-7.98 13.81M65.95 91.79l5.55 9.16M32.17 24.81h30.02M61.15 84.56l15.28-26.47M24.26 79.43 8.59 52.29",
    className: "PH-Wert_svg__cls-1"
  }))));
};
export default SvgPhWert;